import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "@styles/synchrony-buttons-selectors-theme.scss";
import IconCheck from "@assets/icons/IconCheck";

const RadioCheckboxButton = ({
  dataTestID,
  inputValue,
  checked,
  isRadioType,
  className = "",
  buttonID,
  labelID,
  containerStyle,
  buttonStyle,
  labelStyle,
  textStyle,
  label,
  buttonName,
  disabled = false,
  onClickCallback,
}) => {
  const [labelText, setLabelText] = useState(label);
  useEffect(() => {
    setLabelText(label);
  }, [label]);
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        let { checked, name, value } = e.target;
        if (disabled) {
          return;
        } else {
          onClickCallback(checked, name, value);
        }
      }}
      className={`cursor-pointer opacity-100 ${
        isRadioType ? `` : `checkbox-input ${checked ? `checked` : ""}`
      } ${
        disabled ? "disabled-input" : ""
      } ${className} ${containerStyle}`.trim()}
    >
      <label
        className={`${labelStyle} flex items-center h-max relative
        ${
          isRadioType
            ? " before:content-[''] before:my-0 before:mr-4 before:ml-0 before:w-5 before:h-5 before:rounded-[50%] before:border-2 before:border-solid before:border-color-dark-green"
            : ""
        }
  ${disabled && isRadioType ? " text-color-steel-gray !opacity-40" : ""} `}
        id={labelID}
        htmlFor={inputValue}
      >
        {!isRadioType ? (
          <IconCheck
            iconStyle={`rounded mr-4 ${
              disabled
                ? "bg-color-steel-gray"
                : "bg-color-dark-green cursor-pointer"
            } ${buttonStyle}`}
            iconFillColor={"fill-white"}
            outerFillColor={
              checked
                ? disabled
                  ? "fill-color-steel-gray"
                  : "fill-color-dark-green"
                : "fill-white"
            }
          />
        ) : null}
        <input
          name={inputValue}
          className={`hidden ${buttonStyle}`}
          type={isRadioType ? "radio" : "checkbox"}
          checked={checked}
          readOnly
          id={buttonID}
          data-testid={dataTestID}
        />
        <span
          className={
            checked && isRadioType
              ? "rounded-[50%] w-3.5 h-3.5 left-[3px] absolute block bg-color-dark-green"
              : disabled
                ? "!border-color-steel-gray cursor-auto opacity-50 !bg-color-steel-gray"
                : " "
          }
        ></span>
        {labelText ? <div className={textStyle}>{labelText}</div> : null}
      </label>
    </div>
  );
};

RadioCheckboxButton.propTypes = {
  /** Input Value */
  inputValue: PropTypes.string,
  /** If input is checked */
  checked: PropTypes.bool,
  /** Is input of type radio or checkbox */
  isRadioType: PropTypes.bool,
  /** Input classname */
  className: PropTypes.string,
  /** Input div buttonID */
  buttonID: PropTypes.string,
  /** Label ID */
  labelID: PropTypes.string,
  /** Main container Style */
  containerStyle: PropTypes.string,
  /** Input div button style */
  buttonStyle: PropTypes.string,
  /** Label style */
  labelStyle: PropTypes.string,
  /** Label text */
  label: PropTypes.string,
  /** Input div button name */
  buttonName: PropTypes.string,
  /** Is input disable */
  disabled: PropTypes.bool,
  /** on click call back */
  // onClickCallback: PropTypes.func
};

export default RadioCheckboxButton;
